<ll-titulo>Ver Categoría / Grupo Recurso</ll-titulo>

<grupo-recurso [grupoRecursoTipoId]="grupoRecursoTipoId"></grupo-recurso>
